import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import { STATUS_LABELS, STATUS_COLORS, SNAPSHOT_STATUSES } from '../constants';
import styles from '../DbSnapshots.module.scss';

const StatusPill = ({ status }) => {
  const label = STATUS_LABELS[status] || status;
  const color = STATUS_COLORS[status] || 'gray';

  return (
    <span
      data-testid={`status-pill-${status}`}
      className={cx(styles.statusPill, styles[`status-${color}`])}
      role='status'
      aria-label={`Status: ${label}`}
    >
      {label}
    </span>
  );
};

StatusPill.propTypes = {
  status: PropTypes.oneOf(Object.values(SNAPSHOT_STATUSES)).isRequired,
};

export default StatusPill;
